import React, { Component } from 'react';
import { jsPDF as JsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { Grid, Header, Label, Segment, Table, Button } from 'semantic-ui-react';
import { LoadingBar } from 'components/Commons';
import { TaxInvoiceTable } from 'components/SettlementList/SidePage/SubPage/TaxInvoiceTable';
import Constants from 'components/SettlementList/Constants';
import { connect } from 'react-redux';
import moment from 'moment';
import Preview from 'images/taxInvoicePreview.png';

import numeral from 'numeral';

const tableStyle = {
  taxInvoicePreviewGrid: {
    backgroundImage: `url(${Preview})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center right',
    position: 'relative'
  },
  taxInvoicePreviewRow: {
    opacity: '0.6'
  }
};

const generateStyle = {
  display: 'flex',
  marginTop: '16px',
  marginLeft: 'auto'
};

class TaxInvoice extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.state = {
      visible: false,
      format: [0, 0]
    };
  }

  componentDidUpdate() {
    if (!this.ref.current || this.state.visible) return;
    const { offsetWidth, offsetHeight } = this.ref.current;
    this.setState({ format: [offsetWidth * 0.245, offsetHeight * 0.245], visible: true });
  }

  convertItemDate = (text, start, end) => {
    if (text.length + 1 < end) return null;
    const itemDate = text.substring(start, end);
    return itemDate;
  };

  renderTaxInvoiceStatusLabel = (currentProgressStatus, issueStateCode) => {
    let taxInvoiceLabel;

    if (currentProgressStatus === Constants.PROGRESS_STATUS.APPROVAL) {
      taxInvoiceLabel = (
        <Grid.Column width="6">
          <Label size="large" color="black" ribbon>
            아직 세금계산서 발행 단계가 아닙니다.
          </Label>
        </Grid.Column>
      );
    } else if (issueStateCode === Constants.ISSUE_STATE.SUCCESS) {
      taxInvoiceLabel = (
        <Grid.Column width="6">
          <Label size="large" color="green" ribbon>
            발행된 세금계산서입니다.
          </Label>
        </Grid.Column>
      );
    } else if (issueStateCode === Constants.ISSUE_STATE.REQUEST_AUTO || issueStateCode === Constants.ISSUE_STATE.FAIL) {
      taxInvoiceLabel = (
        <Grid.Column width="6">
          <Label size="large" color="black" ribbon>
            발행중인 세금계산서입니다.
          </Label>
        </Grid.Column>
      );
    } else if (issueStateCode === Constants.ISSUE_STATE.READY) {
      taxInvoiceLabel = (
        <Grid.Column width="6">
          <Label size="large" color="black" ribbon>
            요청대기 중인 세금계산서입니다.
          </Label>
        </Grid.Column>
      );
    }
    return taxInvoiceLabel;
  };

  renderTaxInvoicePreviewGrid = (currentProgressStatus, issueStateCode) => {
    let previewImageStyle = null;

    // 고객사 승인 단계인 경우 혹은 세금계산서 발행이 되지 않은 경우
    if (
      currentProgressStatus === Constants.PROGRESS_STATUS.APPROVAL ||
      (currentProgressStatus === Constants.PROGRESS_STATUS.TAX && issueStateCode !== Constants.ISSUE_STATE.SUCCESS)
    ) {
      previewImageStyle = tableStyle.taxInvoicePreviewGrid;
    }

    return previewImageStyle;
  };

  renderTaxInvoicePreviewRow = (currentProgressStatus, issueStateCode) => {
    let previewOpacityStyle = null;

    // 고객사 승인 단계인 경우 혹은 세금계산서 발행이 되지 않은 경우
    if (
      currentProgressStatus === Constants.PROGRESS_STATUS.APPROVAL ||
      (currentProgressStatus === Constants.PROGRESS_STATUS.TAX && issueStateCode !== Constants.ISSUE_STATE.SUCCESS)
    ) {
      previewOpacityStyle = tableStyle.taxInvoicePreviewRow;
    }

    return previewOpacityStyle;
  };

  renderTaxInvoiceList = (data, step) => {
    const { taxInvoiceList } = data;
    const { currentProgressStatus } = step;

    if (taxInvoiceList.length === 0) {
      return (
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Segment>
                <Grid>
                  <Grid.Row>{this.renderTaxInvoiceStatusLabel(currentProgressStatus, null)}</Grid.Row>
                  <Grid.Row style={{ paddingTop: '0px' }}>
                    <Grid.Column>
                      <Header as="h3" style={{ marginTop: '0px' }}>
                        세금계산서 발행 정보가 없습니다
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      );
    }

    return taxInvoiceList.map((item, index) => (
      <Segment key={index}>
        <Grid.Row>
          <Grid style={this.renderTaxInvoicePreviewGrid(currentProgressStatus, item.issueStateCode)}>
            <Grid.Row>
              <Grid.Column width="6">
                {this.renderTaxInvoiceStatusLabel(currentProgressStatus, item.issueStateCode)}
              </Grid.Column>
              <Grid.Column width="10">
                <Header as="h3" style={{ marginTop: '5px', marginLeft: '15px' }}>
                  {item.taxInvoiceTitle}
                </Header>
              </Grid.Column>
            </Grid.Row>
            <div ref={this.ref} style={{ width: '100%' }} className={`pdf-content-${index}`}>
              <Grid.Row
                className="taxInvoice"
                style={this.renderTaxInvoicePreviewRow(currentProgressStatus, item.issueStateCode)}
              >
                <Grid.Column>
                  <div className="table-box" style={{ marginTop: '3px' }}>
                    <TaxInvoiceTable descr={item} />
                  </div>
                  <div className="table-box" style={{ marginTop: '3px' }}>
                    <Table celled>
                      <Table.Body>
                        <Table.Row className="thead">
                          <Table.Cell width={2}>작성일자</Table.Cell>
                          <Table.Cell width={4}>공급가액</Table.Cell>
                          <Table.Cell width={3}>세액</Table.Cell>
                          <Table.Cell width={3}>수정사유</Table.Cell>
                          <Table.Cell width={4}>비고</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>{moment(item.taxInvoiceYmd).format('YYYY-MM-DD')}</Table.Cell>
                          <Table.Cell className="amt">{numeral(item.taxSupplyAmt).format('0,0')}</Table.Cell>
                          <Table.Cell className="amt">{numeral(item.taxTaxAmt).format('0,0')}</Table.Cell>
                          <Table.Cell />
                          <Table.Cell colSpan={3}>{item.remark1}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </div>
                  <div className="table-box" style={{ marginTop: '3px' }}>
                    <Table celled>
                      <Table.Body>
                        <Table.Row className="thead">
                          <Table.Cell style={{ width: 20 }}>월</Table.Cell>
                          <Table.Cell style={{ width: 20 }}>일</Table.Cell>
                          <Table.Cell width={3}>품목</Table.Cell>
                          <Table.Cell width={1}>규격</Table.Cell>
                          <Table.Cell width={1}>수량</Table.Cell>
                          <Table.Cell width={1}>단가</Table.Cell>
                          <Table.Cell width={3}>공급가액</Table.Cell>
                          <Table.Cell width={3}>세액</Table.Cell>
                          <Table.Cell>비고</Table.Cell>
                        </Table.Row>
                        {item.taxInvoiceItemList.map((detail) => (
                          <Table.Row key={detail.itemSeq}>
                            <Table.Cell>{this.convertItemDate(item.taxInvoiceYmd, 4, 6)}</Table.Cell>
                            <Table.Cell>{this.convertItemDate(item.taxInvoiceYmd, 6, 8)}</Table.Cell>
                            <Table.Cell>{detail.itemText}</Table.Cell>
                            <Table.Cell />
                            <Table.Cell />
                            <Table.Cell />
                            <Table.Cell className="amt">{numeral(detail.itemSupplyAmt).format('0,0')}</Table.Cell>
                            <Table.Cell className="amt">{numeral(detail.itemTaxAmt).format('0,0')}</Table.Cell>
                            <Table.Cell>{detail.description}</Table.Cell>
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>
                  </div>
                  <div className="table-box" style={{ marginTop: '3px' }}>
                    <Table celled>
                      <Table.Body>
                        <Table.Row className="thead">
                          <Table.Cell width={4}>합계금액</Table.Cell>
                          <Table.Cell width={2}>현금</Table.Cell>
                          <Table.Cell width={2}>수표</Table.Cell>
                          <Table.Cell width={2}>어음</Table.Cell>
                          <Table.Cell width={2}>외상미수금</Table.Cell>
                          <Table.Cell className="except" width={4} rowSpan={2}>
                            이 금액을 <span>[청구]</span>함.
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className="amt">{numeral(item.taxTotalAmt).format('0,0')}</Table.Cell>
                          <Table.Cell />
                          <Table.Cell />
                          <Table.Cell />
                          <Table.Cell />
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </div>
                  <div className="table-box" style={{ marginTop: '15px' }}>
                    {this.renderPreviewBottomDiv(currentProgressStatus, item.issueStateCode)}
                  </div>
                </Grid.Column>
              </Grid.Row>
            </div>
          </Grid>
        </Grid.Row>
        {item.issueStateCode === Constants.ISSUE_STATE.SUCCESS ? (
          <Button inverted color="green" style={generateStyle} onClick={() => this.generatePdf(item.title, index)}>
            PDF 다운로드
          </Button>
        ) : null}
      </Segment>
    ));
  };

  renderConsignCountInfo = (data) => {
    const { consignCountObject } = data;

    if (consignCountObject.consignCount === 0) {
      return null;
    }

    return (
      <div className="bottom-text">
        <Segment compact>
          <span>
            ※ 위수탁 세금계산서 {consignCountObject.consignCount} 건 중{consignCountObject.consignCompleteCount} 건 발행
            되었습니다.
          </span>
        </Segment>
      </div>
    );
  };

  renderPreviewBottomDiv = (currentProgressStatus, issueStateCode) => {
    let previewBottomDiv;

    // 고객사 승인 단계인 경우 혹은 세금계산서 발행이 되지 않은 경우
    if (
      currentProgressStatus === Constants.PROGRESS_STATUS.APPROVAL ||
      (currentProgressStatus === Constants.PROGRESS_STATUS.TAX && issueStateCode != Constants.ISSUE_STATE.SUCCESS)
    ) {
      previewBottomDiv = (
        <div className="bottom-text" style={{ color: 'red' }}>
          <Segment compact>
            <span>
              해당 세금계산서는 미리보기 전용으로, 내부 사전 확인용으로만 사용할 수 있으며 그 외 용도로는 사용할수
              없습니다.
            </span>
          </Segment>
        </div>
      );
    }
    return previewBottomDiv;
  };

  generatePdf = (filename, index) => {
    if (!filename || !this.ref.current) return;
    const content = document.querySelector(`.pdf-content-${index}`);
    html2canvas(content, { scale: 4 }).then((canvas) => {
      const img = canvas.toDataURL('image/jpeg');
      const [w, h] = this.state.format;
      const imgHeight = (h * 297) / w;
      const y = imgHeight + 30 > 210 ? 5 : 30;

      const doc = new JsPDF('l', 'mm', 'a4');
      doc.addImage(img, 'JPEG', 5, y, 287, imgHeight);
      doc.save(`${filename}.pdf`);
    });
  };

  render() {
    const { taxInvoice } = this.props;
    const { stepProgress } = this.props;
    let taxInvoiceListTable;
    let consignCountInfoTable;
    let loading = '';

    if (taxInvoice && taxInvoice.data && stepProgress && stepProgress.data) {
      taxInvoiceListTable = this.renderTaxInvoiceList(taxInvoice.data, stepProgress.data);
      consignCountInfoTable = this.renderConsignCountInfo(taxInvoice.data);
    } else {
      loading = <LoadingBar />;
    }

    return (
      <div>
        {loading}
        {taxInvoiceListTable}
        {consignCountInfoTable}
      </div>
    );
  }
}

TaxInvoice = connect((state) => ({
  taxInvoice: state.settlement.taxInvoiceList,
  stepProgress: state.settlement.progressStatus
}))(TaxInvoice);

export default TaxInvoice;
